import { useState } from "react";
import { Tooltip } from "react-tooltip";
import { ChevronIcon } from "./DocumentRowIcons";

// Shared card shell matching the WoProposals / WoForms design: white rounded
// card, light-blue header bar with a collapsible chevron, optional count badge,
// tooltip, header action, and a grid-rows expand/collapse animation.
//
// Use this instead of CollapsableComponent for the WO detail sections so they
// all share the proposals/forms look.
function WoSectionCard({
  title,
  count,
  toolTip = "",
  defaultOpen = false,
  headerAction = null,
  // Extra content in the header's left group after the count/tooltip —
  // e.g. the "| Total: $X ⓘ" block on the Purchase Orders section.
  headerExtra = null,
  // Removes the body padding so full-width content (e.g. the Purchase Orders
  // table) runs flush against the card edges.
  flush = false,
  children,
}) {
  const [expanded, setExpanded] = useState(defaultOpen);

  // A real border (not an inset outline) so sticky children inside the
  // overflow clip can never paint over the card edge.
  return (
    <div className="w-full bg-white rounded-[12px] overflow-hidden shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] border border-[#E5E8F3]">
      {/* Header (click anywhere to expand/collapse) */}
      <div
        onClick={() => setExpanded((prev) => !prev)}
        className="w-full px-6 py-4 flex items-center justify-between bg-[#F8F9FE] border-b border-[#E5E8F3] cursor-pointer"
      >
        <div className="flex items-center gap-3">
          <span className="font-OpenSansSemiBold text-[14px] leading-[20px] tracking-[0.14px] capitalize text-[#1A2332]">
            {title}
          </span>
          {typeof count === "number" && (
            <span className="min-w-[24px] px-2 py-[2px] flex items-center justify-center rounded-[16px] bg-[#EEF0F9] font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] text-[#5F6477]">
              {count}
            </span>
          )}
          {toolTip && (
            <>
              <img
                src="/images/common/tooltip.png"
                alt="info"
                data-tooltip-id={title}
                data-tooltip-html={toolTip}
                className="w-3 h-3"
                onClick={(e) => e.stopPropagation()}
              />
              <Tooltip id={title} positionStrategy="fixed" />
            </>
          )}
          {headerExtra}
        </div>
        <div className="flex items-center gap-4">
          {headerAction}
          <ChevronIcon expanded={expanded} />
        </div>
      </div>

      {/* Grid-rows 0fr->1fr animates the body height without a fixed max-height. */}
      <div
        className={`w-full grid transition-[grid-template-rows] duration-300 ease-in-out ${
          expanded ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        }`}
      >
        <div className="w-full min-h-0 overflow-hidden">
          <div className={`w-full ${flush ? "" : "px-6 py-4"}`}>{children}</div>
        </div>
      </div>
    </div>
  );
}

export default WoSectionCard;
